import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

interface VasMaintenanceProps {

    toggleSelections: Function
    waitingReview: boolean
    HasUnreviewedMaintenances: boolean
    HasOverdueMaintenance: boolean
    isChrome: boolean
}


class VasMaintenance extends Component<VasMaintenanceProps, {}> {

    render() {
        return (
            <div className="VasMaintenance">
                <div id="vas-maintenance-btn-HasOverdueMaintenance">
                    {!this.props.HasUnreviewedMaintenances &&
                        <Button onClick={() => this.props.toggleSelections(["HasUnreviewedMaintenances-t"])} tabIndex={-1}>
                            <div id="vas-inspections-maintenance-btn-content-wrapper">
                                {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} onClick={() => this.props.toggleSelections(["HasUnreviewedMaintenances-t"])}></input>}
                                {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} onClick={() => this.props.toggleSelections(["HasUnreviewedMaintenances-t"])}></input>}
                                <span id="unreviewed-maintenance-icon" className="material-icons">build</span>
                                <p>Waiting Maintenance Review</p>
                            </div>
                        </Button>}
                    {this.props.HasUnreviewedMaintenances &&
                        <Button id="vas-unreviewed-maintenance-checked" onClick={() => this.props.toggleSelections(["HasUnreviewedMaintenances-f"])} tabIndex={-1}>
                            <div id="vas-inspections-maintenance-btn-content-wrapper">
                                {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.props.toggleSelections(["HasUnreviewedMaintenances-f"])}></input>}
                                {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.props.toggleSelections(["HasUnreviewedMaintenances-f"])}></input>}
                                <span id="unreviewed-maintenance-icon" className="material-icons">build</span>
                                <p>Waiting Maintenance Review</p>
                            </div>
                        </Button>}
                </div>
                <div id="vas-maintenance-btn-HasOverdueMaintenance">
                    {!this.props.HasOverdueMaintenance &&
                        <Button onClick={() => this.props.toggleSelections(["HasOverdueMaintenance-t"])} tabIndex={-1}>
                            <div id="vas-inspections-maintenance-btn-content-wrapper">
                                {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} onClick={() => this.props.toggleSelections(["HasOverdueMaintenance-t"])}></input>}
                                {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} onClick={() => this.props.toggleSelections(["HasOverdueMaintenance-t"])}></input>}
                                <span id="overdue-maintenance-icon" className="material-icons-outlined">build_circle</span>
                                <p>Overdue Maintenance</p>
                            </div>
                        </Button>}
                    {this.props.HasOverdueMaintenance &&
                        <Button id="vas-overdue-maintenance-checked" onClick={() => this.props.toggleSelections(["HasOverdueMaintenance-f"])} tabIndex={-1}>
                            <div id="vas-inspections-maintenance-btn-content-wrapper">
                                {this.props.isChrome && <input id="fleet-chrome-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.props.toggleSelections(["HasOverdueMaintenance-f"])}></input>}
                                {!this.props.isChrome && <input id="fleet-fox-radio" type="checkbox" tabIndex={-1} defaultChecked onClick={() => this.props.toggleSelections(["HasOverdueMaintenance-f"])}></input>}
                                <span id="overdue-maintenance-icon" className="material-icons-outlined">build_circle</span>
                                <p>Overdue Maintenance</p>
                            </div>
                        </Button>}
                </div>
            </div>
        )
    }

}

export default VasMaintenance